/* eslint-disable max-len */
export default {
  en: {
    page: {
      titleApprovers: 'Merge request approvers',
      titleAutoMerge: 'Auto-merge rules',
      description:
        'Set the number of required approvals, responsible, and other pull request settings.',
      description_link: 'Show more',
      rules: 'Approval rules',
      table: {
        title: 'Title',
        approvers: 'Approver',
        target_branch: 'Target branch',
        count: 'Number of approvals'
      },
      add_rule: 'Add rule',
      checkboxes: {
        rule1: 'Can override approvers and approvals required per merge request',
        rule2:
          'Remove all approvals in a merge request when new commits are pushed to its source branch',
        rule3: 'Prevent approval of merge request by merge request author',
        rule4: 'Prevent approval of merge requests by merge request committers',
        rule5: 'Require user password to approve',
        rule6: 'Check last pipeline status before merging',
        rule7: 'Allow editing of a merged request',
        rule8: 'Remove all approvals in a merge request when target branch is changed',
        rule9: 'Allow editing of merge commit messages',
        rule10: 'The "Delete branch after merge" option is enabled by default',
        rule11: 'Check merge result pipeline status',
        rule12: 'Check merge pipeline status',
        rule13: 'Check branch pipeline status'
      },
      autoMergeCheckboxes: {
        rule1: 'Allow auto-merge',
        rule2: 'Check for conflicts',
        rule3: 'Check for closed discussions',
        rule4: 'Check for approval of responsible persons',
        rule5: 'Check for a successful pipeline'
      },
      save: 'Save',
      popup: {
        title_add: 'Adding a rule',
        title_edit: 'Edit a rule',
        cancel_btn: 'Cancel',
        btn_add: 'Add',
        btn_save: 'Save'
      },
      confirm_delete: {
        message: 'Delete the rule?',
        title: 'Are you sure you want to delete the rule?',
        cancel_title: 'Cancel',
        ok_title: 'Confirm'
      },
      mergeRequestRules: {
        title: 'Merge Request Methods',
        mergeCommitCreate: 'Create a merge commit',
        mergeCommitDescription: 'Each merge creates a merge commit.',
        semiLinearCreate:
          'Create a merge commit with a partially linear history (semilinear history)',
        semiLinearDescription:
          'Each merge creates a merge commit. If the merge was not possible due to the fact that the target branch is not up-to-date with the source branch, the source branch will be rebased to the target branch.',
        fastForwardCreate: 'Fast-forward Merge',
        fastForwardDescription:
          'No merge commit will be created. If the merge was not possible due to the fact that the target branch is not up-to-date with the source branch, the source branch will be rebased to the target branch.'
      }
    },
    approval_form: {
      title: 'Title',
      approvers_placeholder: 'Approvers',
      target_branch_placeholder: 'Target branch',
      minimal_approvals_placeholder: 'Minimal approvals number',
      minimal_approvals_small_text: 'Make sure you have added owners'
    },
    approves: {
      title: 'Request approves',
      not_approved: 'Request is not approved',
      cancel_approve: 'Cancel approval',
      approve: 'Approve request'
    },
    approval_rules: {
      title: 'Approval rules',
      table: {
        h1: 'Approvers',
        h2: '',
        h3: 'Approvals',
        h4: 'Approved By',
        of: 'of',
        not_approved: 'None'
      }
    },
    squash_commit_rules: {
      title: 'Rules for squash commit',
      description: 'Set the default behavior of this function in merge requests',
      rule1_title: 'Prohibited',
      rule2_title: 'Allowed',
      rule3_title: 'Recommended',
      rule4_title: 'Required',
      rule1_description: 'Squash commit is not available, the checkbox for choosing is hidden',
      rule2_description:
        'Squash commit is available, the checkbox for selection is visible and not selected by default.',
      rule3_description:
        'Squash commit is available, the checkbox for selection is visible and selected by default.',
      rule4_description:
        'Squash commit is available, the checkbox for selection is visible and always selected, without the possibility of switching it off'
    },
    template_messages: {
      templates: 'Merge template messages',
      use: 'Allow editing template messages when creating a merge',
      merge_commit_title: 'Merge commit message template',
      merge_commit_description:
        'The commit message used when merging, if the merge method creates a merge commit',
      squash_commit_title: 'Squash commit message template',
      squash_commit_description: 'The commit message used when squashing commits',
      merge_request_description_title: 'Merge request description template',
      merge_request_description_description: 'The default description for merge request'
    }
  },
  ru: {
    page: {
      titleApprovers: 'Ответственные за запросы на слияние',
      titleAutoMerge: 'Правила автоматического слияния',
      description:
        'Задайте количество необходимых одобрений, ответственных и другие настройки запросов на слияния.',
      description_link: 'Узнать больше',
      rules: 'Правила одобрения слияний',
      table: {
        title: 'Название',
        approvers: 'Ответственные',
        target_branch: 'Целевая ветка',
        count: 'Количество одобрений'
      },
      add_rule: 'Добавить правило',
      checkboxes: {
        rule1:
          'Можно переопределять подтверждающих и подтверждения, необходимые для запроса на слияние',
        rule2:
          'Удалить все подтверждения в запросе на слияние в момент пуша нового коммита в исходную ветку',
        rule3: 'Запретить одобрение запроса на слияние его автором',
        rule4: 'Запретить одобрение запроса его разработчиками',
        rule5: 'Запрашивать пароль при одобрении запроса',
        rule6: 'Проверять статус последнего конвейера при слиянии запроса',
        rule7: 'Разрешить редактирование слитого запроса',
        rule8: 'Удалить все подтверждения в запросе на слияние в момент изменения целевой ветки',
        rule9: 'Разрешить редактирование сообщения коммита слияния',
        rule10: 'Опция "Удаление ветки после слияния" активна по умолчанию',
        rule11: 'Проверять статус конвейера результата слияния',
        rule12: 'Проверять статус конвейера слияния',
        rule13: 'Проверять статус конвейера на ветку'
      },
      autoMergeCheckboxes: {
        rule1: 'Разрешить автоматическое слияние',
        rule2: 'Проверять на отсутствие конфликтов',
        rule3: 'Проверять на закрытие дискуссий',
        rule4: 'Проверять на одобрения ответственных лиц',
        rule5: 'Проверять на успешный конвейер'
      },
      save: 'Сохранить',
      popup: {
        title_add: 'Добавление правила',
        title_edit: 'Редактирование правила',
        cancel_btn: 'Отменить',
        btn_add: 'Добавить правило',
        btn_save: 'Сохранить'
      },
      confirm_delete: {
        message: 'Удалить правило?',
        title: 'Вы уверены, что хотите удалить правило?',
        cancel_title: 'Отменить',
        ok_title: 'Подтвердить'
      },
      mergeRequestRules: {
        title: 'Методы запроса слияния',
        mergeCommitCreate: 'Создать коммит слияния (merge commit)',
        mergeCommitDescription: 'Каждое слияние создает коммит слияния.',
        semiLinearCreate:
          'Создать коммит слияния c частично-линейной историей (semi-linear history)',
        semiLinearDescription:
          'Каждое слияние создает коммит слияния. Если слияние невозможно из-за неактуальности исходной ветки по отношению к целевой, будет предложено перебазировать исходную ветку на целевую.',
        fastForwardCreate: 'Слияние fast-forward',
        fastForwardDescription:
          'Коммит слияния не будет создан. Если слияние невозможно из-за неактуальности исходной ветки по отношению к целевой, будет предложено перебазировать исходную ветку на целевую.'
      }
    },
    approval_form: {
      title: 'Название',
      approvers_placeholder: 'Ответственные',
      target_branch_placeholder: 'Целевая ветка',
      minimal_approvals_placeholder: 'Минимальное количество одобрений',
      minimal_approvals_small_text: 'Убедитесь, что вы добавили ответственных'
    },
    approves: {
      title: 'Запрос одобрили',
      not_approved: 'Запрос не одобрен',
      cancel_approve: 'Отменить одобрение',
      approve: 'Одобрить запрос'
    },
    approval_rules: {
      title: 'Правила одобрения запросов',
      table: {
        h1: 'Утверждающие',
        h2: '',
        h3: 'Условия',
        h4: 'Одобрено',
        of: 'из',
        not_approved: 'Еще не одобрено'
      }
    },
    squash_commit_rules: {
      title: 'Правила слияния одним коммитом',
      description: 'Задайте стандартное поведение этой функции в запросах на слияние',
      rule1_title: 'Запрещено',
      rule2_title: 'Разрешено',
      rule3_title: 'Рекомендовано',
      rule4_title: 'Обязательно',
      rule1_description: 'Слияние одним коммитом будет недоступно, чекбокс для выбора скрыт',
      rule2_description:
        'Слияние одним коммитом доступно, чекбокс для выбора видимый и не выбран по умолчанию',
      rule3_description:
        'Слияние одним коммитом доступно, чекбокс для выбора видимый и выбран по умолчанию',
      rule4_description:
        'Слияние одним коммитом доступно, чекбокс для выбора видимый и выбран всегда, без возможности выключения'
    },
    template_messages: {
      templates: 'Шаблоны сообщений слияния',
      use: 'Разрешить редактирование шаблонных сообщений при выполнении слияния',
      merge_commit_title: 'Шаблон сообщения коммита слияния (merge commit)',
      merge_commit_description:
        'Сообщение коммита используемое если создается коммит слияния (merge commit)',
      squash_commit_title: 'Шаблон сообщения слияния одним коммитом (squash commit)',
      squash_commit_description:
        'Сообщение коммита используемое если включена опция слияния одним коммитом (squash commit)',
      merge_request_description_title: 'Шаблон описания запроса на слияние',
      merge_request_description_description:
        'Стандартное описание используемое в запросе на слияние'
    }
  }
};
